import { render, staticRenderFns } from "./couponListPopup.vue?vue&type=template&id=55a46ae2&scoped=true&"
import script from "./couponListPopup.vue?vue&type=script&lang=ts&"
export * from "./couponListPopup.vue?vue&type=script&lang=ts&"
import style0 from "./couponListPopup.vue?vue&type=style&index=0&id=55a46ae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a46ae2",
  null
  
)

export default component.exports